import { RemixiconReactIconComponentType } from 'remixicon-react';
import InformationFillIcon from 'remixicon-react/InformationFillIcon';
import CheckDoubleIcon from 'remixicon-react/CheckDoubleFillIcon';
import AlertFillIcon from 'remixicon-react/AlertFillIcon';
import { PopupModalTheme } from '..';
import { FeaturedIcon } from '../../featured-icon';

const iconMap: {
  [key in PopupModalTheme]: RemixiconReactIconComponentType;
} = {
  primary: InformationFillIcon,
  success: CheckDoubleIcon,
  danger: InformationFillIcon,
  warning: AlertFillIcon,
};

const Cosmetic = ({
  theme,
  headerSide,
  overrideIcon,
}: {
  theme: PopupModalTheme;
  headerSide?: 'left' | 'top';
  overrideIcon?: RemixiconReactIconComponentType | string;
}) => {
  const Icon = typeof overrideIcon !== 'string' ? overrideIcon || iconMap[theme] : null;
  const imageSrc = typeof overrideIcon === 'string' ? overrideIcon : null;

  return (
    <div className="relative flex">
      <div
        className={`${headerSide === 'left' ? 'h-full w-10 rounded-l-lg' : 'h-10 w-full rounded-t-lg'} bg-${theme}`}
      />
      {/* <div
        className={`lg:w-[40px] bg-${theme} lg:rounded-l-large rounded-t-large h-[40px] w-full lg:h-full lg:rounded-tr-none`}
      ></div> */}
      <div
        className={`absolute  ${
          headerSide === 'left' ? 'left-[18px] top-[15px] lg:top-[28px]' : 'left-[15px] top-[18px] lg:left-[28px]'
        }`}
      >
        {Icon && <FeaturedIcon icon={Icon} color={theme} size="lg" type="circle" />}
        {imageSrc && <img src={imageSrc} alt="icon" className="h-11 w-11 max-w-none" />}
      </div>
    </div>
  );
};

export default Cosmetic;
